/** The pages a MoreMe super admin (super-super-admin) may open; everything else redirects to /admin/super. */
const SUPER_ADMIN_PREFIXES = ['/admin/super', '/admin/mood-analytics', '/admin/moreme-courses', '/admin/lms/courses/'];
const SUPER_ADMIN_PAGES = ['/profile', '/settings'];

export function superAdminMayOpen(pathname: string): boolean {
  return SUPER_ADMIN_PAGES.includes(pathname) || SUPER_ADMIN_PREFIXES.some((p) => pathname.startsWith(p));
}
